import axios from 'axios';

const getContratacoes = (params) => axios.get('/contratacoes-fretes/all', {
  params,
});

const getContratacao = (id) => axios.get(`/contratacoes-fretes/all/${id}`);


const enviarEmailFinalizacao = (id) => axios.put(`/contratacoes-fretes/${id}/email`, {});
const enviarWhatsappFinalizacao = (id) => axios.put(`/contratacoes-fretes/${id}/whatsapp`, {});

export default {
  getContratacoes,
  getContratacao,
  enviarEmailFinalizacao,
  enviarWhatsappFinalizacao,
};
